/**
 * EK-039 — PDP sticky add to cart behavior test (mobile).
 *
 * Two behaviors coexist in the live theme, keyed off one attribute on <html>:
 *
 *   data-ek-atc-mode="always"  (control) — the fixed bar is visible from page
 *     load, exactly as today. This script does nothing.
 *   data-ek-atc-mode="scroll"  (variant) — the buy box button renders inline
 *     on mobile (CSS in snippets/context-menu.liquid) and the fixed bar only
 *     appears once the shopper has scrolled past that inline button. Scrolling
 *     back up to the inline button hides the bar again, so the same purchase
 *     action is never on screen twice.
 *
 * The attribute is set before first paint by the inline script in
 * snippets/main-product.liquid, resolving:
 *   window.EKSTER_STICKY_ATC ('always' | 'scroll', Intelligems override)
 *   > product metafield custom.sticky_atc_mode
 *   > Footer block setting sticky_atc_mode
 *   > 'always'.
 *
 * The bar toggles a class that only changes opacity / visibility / transform
 * on a position:fixed element, so the state change cannot cause layout shift.
 */
(function () {
  'use strict';

  var SHOWN_CLASS = 'ek-sticky-atc--shown';
  var observer = null;

  function currentMode() {
    var attr = document.documentElement.getAttribute('data-ek-atc-mode');
    if (attr === 'scroll' || attr === 'always') return attr;

    // The attribute script did not run (e.g. section rendered in isolation):
    // fall back to the override, then the server-resolved value on the bar.
    var override = window.EKSTER_STICKY_ATC;
    if (override === 'scroll' || override === 'always') return override;

    var bar = document.querySelector('.ek-sticky-atc[data-ek-atc-mode]');
    if (bar && bar.getAttribute('data-ek-atc-mode') === 'scroll') return 'scroll';
    return 'always';
  }

  function init() {
    var bar = document.querySelector('.ek-sticky-atc[data-ek-atc-mode]');
    if (!bar) return;

    if (observer) {
      observer.disconnect();
      observer = null;
    }
    bar.classList.remove(SHOWN_CLASS);

    // Control: leave the bar exactly as the theme renders it today.
    if (currentMode() !== 'scroll') return;

    // No IntersectionObserver support: fail open to the persistent bar so the
    // purchase action is never lost.
    if (!('IntersectionObserver' in window)) {
      bar.classList.add(SHOWN_CLASS);
      return;
    }

    var anchor = document.querySelector('.main-product-footer[data-ek-atc-footer]');
    if (!anchor) {
      // No inline buy box on this template (e.g. a PDP section without the
      // footer block): fail open to the persistent bar.
      bar.classList.add(SHOWN_CLASS);
      return;
    }

    var button = anchor.querySelector('button[name="add"]') || anchor;

    observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[entries.length - 1];
        // "Not intersecting" alone is not enough — that is also true before
        // the shopper has reached the inline button from above (it sits below
        // the fold at load). Only count it as scrolled past once the button
        // has moved above the top of the viewport.
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle(SHOWN_CLASS, scrolledPast);
      },
      { threshold: 0 }
    );
    observer.observe(button);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-bind after a section rerender.
  document.addEventListener('shopify:section:load', init);
})();
